import { connect } from 'react-redux';
import AddClient from './AddClient';

import { createClient } from './actions';


const mapStateToProps = state => ({
    isVisible: state.addClientUI.isVisible,
    isLocked: state.isLockedUI.isLocked,
    companyName: state.clientInfoUI.companyName,
    street: state.clientInfoUI.street,
    street2: state.clientInfoUI.street2,
    Zip: state.clientInfoUI.Zip,
    city: state.clientInfoUI.city,
    country: state.clientInfoUI.country,
    selectedState: state.clientInfoUI.selectedState,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
    clientUpdateStatus: state.addClientUI.clientUpdateStatus,
    phone: state.contactUI.phone,
    email: state.contactUI.email,
    position: state.contactUI.position,
    authToken: state.auth.authToken,
});

const mapDispatchToProps = dispatch => ({
    createClient: (client, authToken) => dispatch(createClient(client, authToken)),
});


export default connect(mapStateToProps, mapDispatchToProps)(AddClient);



// WEBPACK FOOTER //
// ./src/containers/AddClient/index.js